var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaderboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94766 12.8333H3.66683C2.6585 12.8333 1.8335 13.6583 1.8335 14.6666V20.1666H7.94766V12.8333Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2193 9.16675H9.77181C8.76348 9.16675 7.93848 9.99175 7.93848 11.0001V20.1667H14.0526V11.0001C14.0526 9.99175 13.2368 9.16675 12.2193 9.16675Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3336 15.5833H14.0527V20.1666H20.1669V17.4166C20.1669 16.4083 19.3419 15.5833 18.3336 15.5833Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4769 1.89758L11.9627 2.86925C12.0269 3.00675 12.201 3.13508 12.3477 3.15341L13.2277 3.30008C13.7869 3.39175 13.9244 3.80423 13.521 4.1984L12.8335 4.8859C12.7144 5.00506 12.6502 5.22507 12.6869 5.3809L12.8794 6.22425C13.0352 6.89342 12.6777 7.15009 12.091 6.80175L11.266 6.31592C11.1194 6.22426 10.8719 6.22426 10.7252 6.31592L9.90021 6.80175C9.31354 7.15009 8.95604 6.89342 9.11188 6.22425L9.30438 5.3809C9.34105 5.22507 9.27688 4.9959 9.15771 4.8859L8.47938 4.20757C8.07604 3.80424 8.20438 3.4009 8.77271 3.30923L9.65271 3.16259C9.79938 3.13509 9.97354 3.00676 10.0377 2.87842L10.5235 1.90673C10.7894 1.37506 11.211 1.37508 11.4769 1.89758Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardIcon);
export default __webpack_public_path__ + "static/media/leaderboardIcon.0303c8babed3fb79846e0e2a1e7950bd.svg";
export { ForwardRef as ReactComponent };